import baseAPI from "@/api/base";
import { EditMeeting, GetMeeting, RegisterMeeting, RescheduleMeeting } from "@/dtos/Meeting.dto";
import {
  DELETE_MEETING_URL,
  EDIT_MEETING_URL,
  RESCHEDULE_MEETING_URL,
  GENERATE_MEETING_LINK_URL,
  GET_MEETING_STATS_URL,
  GET_MEETING_URL,
  REGISTER_MEETING_URL,
  TOGGLE_MEETING_IS_ACTIVE_URL,
  GET_EXTERNAL_BUSY_SLOTS_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Meeting {
  static getMeetings = async (getMeeting: GetMeeting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MEETING_URL, {
      params: getMeeting,
    });
    return response;
  };

  static getMeetingStats = async (getMeeting: GetMeeting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MEETING_STATS_URL, {
      params: getMeeting,
    });
    return response;
  };

  static generateMeetingLink = async (registerMeeting: RegisterMeeting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(GENERATE_MEETING_LINK_URL, {
      ...registerMeeting,
    });
    return response;
  };

  static registerMeeting = async (registerMeeting: RegisterMeeting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_MEETING_URL, {
      ...registerMeeting,
    });
    return response;
  };

  static editMeeting = async (editMeeting: EditMeeting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_MEETING_URL, {
      ...editMeeting,
    });
    return response;
  };

  static rescheduleMeeting = async (
    rescheduleMeeting: RescheduleMeeting
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(RESCHEDULE_MEETING_URL, {
      ...rescheduleMeeting,
    });
    return response;
  };

  static toggleMeetingIsActive = async (editMeeting: EditMeeting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_MEETING_IS_ACTIVE_URL, {
      ...editMeeting,
    });
    return response;
  };

  static deleteMeeting = async (ids: string | string[]): Promise<AxiosResponse> => {
    // Support both single ID (string) or multiple IDs (array)
    const idsParam = Array.isArray(ids) ? ids.join(",") : ids;
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_MEETING_URL}/${idsParam}`);
    return response;
  };

  static getMeetingAttendees = async (meetingId: string): Promise<AxiosResponse> => {
    return baseAPI.get(`${GET_MEETING_URL}/${meetingId}/attendees`);
  };

  static exportMeetings = async (params: { meetingIds?: string[] }): Promise<AxiosResponse> => {
    return baseAPI.post("/report/meetings/export", params, { responseType: "blob" });
  };

  static getExternalBusySlots = async (params: {
    date: string;
    timezone?: string;
  }): Promise<AxiosResponse> => {
    return baseAPI.get(GET_EXTERNAL_BUSY_SLOTS_URL, { params });
  };
}

export default Meeting;
